import Treemap from "../../../src/visualization/connectedCharts/ConnectedTreemap";
import { buildMeta } from "../../routeMeta";

export function meta(args) {
  return buildMeta(
    {
      title: "Tree Map — The Atlas of Economic Complexity",
      description:
        "Visualize the composition of a country's exports or imports as a tree map.",
      ogImage: "share_tree.png",
    },
    args,
  );
}

export default function TreemapRoute() {
  return <Treemap />;
}
